import React from "react";
import PropTypes from "prop-types";

import { FileExclamationPoint } from "lucide-react";

import { UIButton } from "../../../../ui";
import {
  CAPACITY_STATES,
  fillTemplate,
  formatAmount,
  getCapacityState,
} from "../../../Form/Steps/ChooseCrewSize/crewSizeUtils";
import PaymentNotice from "../../PaymentNotice";

/** Used organizers out of the crew size ceiling, with the "Upgrade Crew Size" action. */
const CapacityBanner = ({
  t,
  used,
  ceiling,
  sizeLabel,
  onUpgrade,
  cancelRequestLabel,
  onCancelRequest,
  pendingMessage,
}) => {
  const atCapacity = getCapacityState(used, ceiling) !== CAPACITY_STATES.below;

  return (
    <PaymentNotice
      className="capacity-banner"
      icon={<FileExclamationPoint size={24} aria-hidden />}
      title={fillTemplate(atCapacity ? t.atCapacity : t.capacity, {
        used: formatAmount(used),
        ceiling: formatAmount(ceiling),
        size: sizeLabel,
      })}
      // A pending upgrade: what was sent and when, in place of the upgrade hint.
      description={pendingMessage || t.message}
      action={
        // A pending upgrade request replaces the upgrade action with its cancellation.
        onCancelRequest ? (
          <UIButton type="button" color="error" onClick={onCancelRequest}>
            {cancelRequestLabel}
          </UIButton>
        ) : onUpgrade ? (
          <UIButton type="button" appearance="gradient" onClick={onUpgrade}>
            {t.upgrade}
          </UIButton>
        ) : null
      }
    />
  );
};

CapacityBanner.propTypes = {
  /** `events.viewEvents.crewSizeUpgrade.banner` copy. */
  t: PropTypes.object.isRequired,
  used: PropTypes.number.isRequired,
  ceiling: PropTypes.number.isRequired,
  sizeLabel: PropTypes.string.isRequired,
  /** Omit to hide the "Upgrade Crew Size" action. */
  onUpgrade: PropTypes.func,
  cancelRequestLabel: PropTypes.string,
  /** A pending upgrade request: shows "Cancel Upgrade Request" in place of the upgrade action. */
  onCancelRequest: PropTypes.func,
  /** A pending upgrade request, e.g. "Upgrade to Large awaiting … · 1,500 SAR submitted on 22-03-2026." */
  pendingMessage: PropTypes.string,
};

CapacityBanner.defaultProps = {
  onUpgrade: undefined,
  cancelRequestLabel: undefined,
  onCancelRequest: undefined,
  pendingMessage: undefined,
};

export default CapacityBanner;
